import { render, staticRenderFns } from "./ItemCardSection.vue?vue&type=template&id=53375436&scoped=true&"
import script from "./ItemCardSection.vue?vue&type=script&lang=js&"
export * from "./ItemCardSection.vue?vue&type=script&lang=js&"
import style0 from "./ItemCardSection.vue?vue&type=style&index=0&id=53375436&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53375436",
  null
  
)

export default component.exports